'use strict';

export default class VK {
	constructor() {
		this.videos = document.querySelectorAll('[data-video-vk]');

		this.init();
	}

	init() {
		this.videos.forEach(video => {
		    video.addEventListener('click', function(event) {
				const iframeUrl = "//vkvideo.ru/video_ext.php?" + event.target.dataset.videoVk + "?autoplay=1&autohide=1";
				const iframe = document.createElement('iframe', {'allowfullscreen':'allowfullscreen', 'frameborder': '0', 'src': iframeUrl});
				iframe.setAttribute('allowfullscreen', 'allowfullscreen');
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute('src', iframeUrl);
				event.target.append(iframe);
			});
		});
	}
}